export const RNPushNotification = {
  cancelAllLocalNotifications: () => {},
  localNotificationSchedule: () => {},
  configure: () => {},
};
export const RNPushNotificationIOS = { FetchResult: { NoData: '' } };
